export enum ConnectionType {
    HelixEntity = 'HelixEntity',
}
